/* eslint-disable prefer-destructuring */
import { ENUM_STATUS_GAME } from "constants"

import React, { useState } from "react"

import Equal from "containers/Machine/Equal"
import GetShadow from "containers/Machine/GetShadow"
import SetShadow from "containers/Machine/SetShadow"
import Wait from "containers/Machine/Wait"
import { useAppContext } from "contexts/AppProvider"
import { AiFillHome } from "react-icons/ai"
import { BsInfoCircleFill } from "react-icons/bs"
import { useNavigate } from "react-router-dom"

export default function Machine(){
    const { setIsModalTutorialDisplayed } = useAppContext()

    const navigate = useNavigate()

    const [status, setStatus] = useState(ENUM_STATUS_GAME.READY)
    const [shadow, setShadow] = useState(null)
    const [series, setSeries] = useState([])
    const [amIsetShadow, setAmIsetShadow] = useState(true)

    const handleBackHome = async() => {
        navigate(`/`, { replace: true })
    }

    const showContent = () => {
        if (status === ENUM_STATUS_GAME.READY){
            return (
                <Wait
                    amIsetShadow={ amIsetShadow }
                    setAmIsetShadow={ setAmIsetShadow }
                    setSeries={ setSeries }
                    setStatus={ setStatus }
                />
            )
        }

        if (status === ENUM_STATUS_GAME.SET_SHADOW){
            return (
                <SetShadow
                    amIsetShadow={ amIsetShadow }
                    setShadow={ setShadow }
                    setStatus={ setStatus }
                />
            )
        }

        if (status === ENUM_STATUS_GAME.GET_SHADOW && shadow){
            let tempSeri = series[0]
            if ((amIsetShadow && !shadow.is_hand_left) || (!amIsetShadow && shadow.is_hand_left)){
                tempSeri = series[1]
            }

            return <GetShadow seri={ tempSeri } setStatus={ setStatus } shadow={ shadow } />
        }

        if (status === ENUM_STATUS_GAME.GET_RESULTS){
            return (
                <Equal
                    amIsetShadow={ amIsetShadow }
                    series={ series }
                    setShadow={ setShadow }
                    setStatus={ setStatus }
                    shadow={ shadow }
                />
            )
        }

        return <></>
    }

    return (
        <>
            { showContent() }

            <div
                className="cursor-pointer fixed bottom-[90px] right-4 p-3 tablet:p-4 text-white bg-primary rounded-full flex-center"
                onClick={ handleBackHome }
            >
                <AiFillHome size={ 24 } />
            </div>

            <div
                className="cursor-pointer fixed bottom-[152px] right-4 p-3 tablet:p-4 text-white bg-quaternary rounded-full flex-center"
                onClick={ () => setIsModalTutorialDisplayed(true) }
            >
                <BsInfoCircleFill size={ 24 } />
            </div>
        </>
    )
}
